<template>
  <IQOS 
    :title="$t('settings_cafe.contacts.address')" 
    :enabled="editing"
    required>
    <GoogleMapDisplay
      class="mt-16"
      :lat="edit_fields.address_location.lat"
      :lon="edit_fields.address_location.lon"
      :zones="[
        {
          lat: edit_fields.address_location.lat,
          lon: edit_fields.address_location.lon,
          radius: 1,
        },
      ]"
      :show_marker="true"
      @pin="onGoogleMapsPinned"
      v-if="editing"
    />

    <BaseInput
      :placeholder="$t('settings_cafe.contacts.address')"
      v-model="edit_fields.address"
      class="mt-16"
      fullWidth
      :disabled="true"
      v-if="!editing"
    />
    <BaseInput
      :placeholder="$t('settings_cafe.contacts.address')"
      :readonly="false"
      v-if="editing"
      :value="edit_fields.address"
      class="mt-16"
      fullWidth
      id="gmapAddressField"
    />

    <template #actions>
      <IQOSActions
        v-model="editing"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>

import GoogleMapDisplay from "@/components/GoogleMapDisplay.vue";

let gmapAutocomplete = null;

export default {
  components: {
    GoogleMapDisplay,
  },
  data() {
    return {
      editing: false,

      edit_fields: {
        address: null,
        address_location: null,
        city: null,
      },
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
      this.$nextTick(() => {
        this.initGoogleWidget();
      });
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.$store.commit('patchCafeGeneralData', this.edit_fields);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    reset() {
      this.edit_fields.address = this.cafe.address;
      this.edit_fields.address_location = this.cafe.address_location || {
        lat: 0,
        lon: 0,
      };
      this.edit_fields.city = this.cafe.city;
    },
    initGoogleWidget() {
      const el = document.getElementById("gmapAddressField");

      const autocomplete = new window.google.maps.places.Autocomplete(el, {
        types: ["geocode"],
      });

      autocomplete.setFields([
        "formatted_address",
        "address_component",
        "geometry",
      ]);

      if (this.owner && this.owner.country) {
        autocomplete.setComponentRestrictions({
          country: this.owner.country.toLowerCase(),
        });
      }

      autocomplete.addListener(
        "place_changed",
        this.onGmapPlaceChange.bind(this)
      );

      gmapAutocomplete = autocomplete;

      if (this.edit_fields.address) {
        el.value = this.edit_fields.address;
      }
    },
    parseGooglePlaceResult(place) {
      const components = place.address_components;

      let city_component = null;

      for (let c = 0; c < components.length; c++) {
        if (components[c].types.includes("locality")) {
          city_component = components[c];
        }
      }

      if (!city_component) {
        city_component = components.find(
          (c) => c.types.includes("locality") || c.types.includes("political")
        );
      }

      this.edit_fields.city = city_component.long_name || "?";

      this.edit_fields.address = place.formatted_address;

      this.edit_fields.address_location = {
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng(),
      };

      document.getElementById(
        "gmapAddressField"
      ).value = this.edit_fields.address;

      console.log(`Parse Google place result`, this.edit_fields)
    },
    onGmapPlaceChange() {
      if (gmapAutocomplete) {
        const place = gmapAutocomplete.getPlace();

        this.parseGooglePlaceResult(place);
      }
    },
    onGoogleMapsPinned(position) {
      this.edit_fields.address_location = position;

      const geocoder = new window.google.maps.Geocoder();

      const vm = this;

      geocoder.geocode(
        {
          location: {
            lat: position.lat,
            lng: position.lon,
          },
        },
        (results, status) => {
          if (status == "OK") {
            if (results[0]) {
              const place = results[0];

              vm.parseGooglePlaceResult(place);
            }
          }
        }
      );
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    owner() {
      return this.$store.state.owner;
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style>
</style>